import { mixPanelEvents } from '@/utils/mixpanel/mixpanelEvents';
import { useCheckSettings, useCurrent, useHasSettings } from 'features/auth';
import { FEATURE_FLAG } from 'types/featureFlag';

import { TopNavbarDropdown } from './TopNavbarDropdown';
import { TopNavbarDropdownItemLink } from './TopNavbarDropdownItemLink';
import { TopNavbarDropdownItemRouterLink } from './TopNavbarDropdownItemRouterLink';

const PANDASCORE_URL = process.env.REACT_APP_PANDASCORE_URL;
const LEM_URL = process.env.REACT_APP_LEM_URL;

export const TopNavbarOperations = () => {
  const [hasSettings] = useCheckSettings();
  const { data } = useCurrent();

  const [isLeaFeatureEnabled] = useHasSettings(FEATURE_FLAG.LEA_FEATURE);
  const [isLemV2FeatureEnabled] = useHasSettings(FEATURE_FLAG.LEM_V2_FEATURE);

  return (
    <TopNavbarDropdown trigger="Operations">
      <>
        <TopNavbarDropdownItemRouterLink to="/self_customer">
          Self Customer
        </TopNavbarDropdownItemRouterLink>

        {hasSettings(FEATURE_FLAG.RENTAL_ASSET_FEATURE) &&
          (isLemV2FeatureEnabled ? (
            <TopNavbarDropdownItemLink href={`${LEM_URL}`} target="_blank">
              LEM
            </TopNavbarDropdownItemLink>
          ) : isLeaFeatureEnabled ? (
            <TopNavbarDropdownItemRouterLink to="/lea">LEA</TopNavbarDropdownItemRouterLink>
          ) : null)}

        {data?.current.customerSettings.includes('enable_routing_feature') &&
          data?.current.userFeatureFlags.includes('routing_allow_configuration') && (
            <TopNavbarDropdownItemRouterLink to="/route_config">
              Route Configuration
            </TopNavbarDropdownItemRouterLink>
          )}

        {data?.current?.customerSettings?.includes('branding_configuration_feature') && (
          <TopNavbarDropdownItemRouterLink to="/customer-portal-configuration">
            Customer Portal Configuration
          </TopNavbarDropdownItemRouterLink>
        )}

        {data?.current?.customerSettings?.includes('branding_configuration_feature') &&
          data?.current?.customerSettings?.includes('customer_portal_v2_feature') && (
            <TopNavbarDropdownItemRouterLink to="/notification-system">
              Notification System
            </TopNavbarDropdownItemRouterLink>
          )}

        {hasSettings(FEATURE_FLAG.USAGE_METRICS_FEATURE) && (
          <TopNavbarDropdownItemLink
            href={`${PANDASCORE_URL}`}
            target="_blank"
            onClick={() => mixPanelEvents.usageMetricsLinkOpened()}
          >
            Usage Metrics
          </TopNavbarDropdownItemLink>
        )}
        {data?.current.customerSettings.includes('check_async_feature') && (
          <TopNavbarDropdownItemRouterLink to="/async_status">
            Async task status
          </TopNavbarDropdownItemRouterLink>
        )}
      </>
    </TopNavbarDropdown>
  );
};
